import { render, staticRenderFns } from "./ProfileCheckup.vue?vue&type=template&id=b31ba3d2&"
import script from "./ProfileCheckup.vue?vue&type=script&lang=js&"
export * from "./ProfileCheckup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports